import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import React from 'react';
import {
  ProductSelectionView,
  ProductSelectionViewProps,
} from '../ProductSelection/ProductSelectionView';

export const ProductSelectionQuickViewView: React.FC<
  GetProductBulkResponse['productSelectionSection'] & ProductSelectionViewProps
> = ({className, ...props}) => {
  if (!props.product?.isSoldOut && props.type?.$case === 'noSiblings') {
    return null;
  }

  return (
    <section className={!props.product.isSoldOut ? className : undefined}>
      <ProductSelectionView
        {...props}
        showProductSelectionAsGrid={props.product.isSoldOut}
      />
    </section>
  );
};
